import React, {useState, useEffect, useRef} from 'react';
import { withRouter } from 'react-router-dom';
import './campaignSale.css';
import '@fontsource/open-sauce-one';
import ProgressMeter from './components/progressMeter/progressMeter';
import baseURLGlobal from '../../utils/util';
import SleekCarousel from './components/sleekCarousel';
import Lottie from "react-lottie";
import iconAnimation from '../../assets/json/web-top-icon.json'
import { config } from '../../appConfig';
import { tutorWebConfig, globalColors, globalText, resolveTutorWebAsset } from './tutorWebConfig';
import { PointsIcon, RankIcon, MessageIcon, ArrowRightIcon } from '../webviewreboot/components/Home/Icons';
const toRgba = (hex, alpha) => {
	const match = /^#([0-9a-f]{6})$/i.exec(hex || '');
	if (!match) return null;
	const n = parseInt(match[1], 16);
	return `rgba(${n >> 16}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
};

const Campaign = (props) => {
	const [data, setData] = useState(null);
	const [showTutorFrame, setShowTutorFrame] = useState(false);
	const [frameUrl, setFrameUrl] = useState("");
	const iframeRef = useRef(null);
	const [isOpen, setIsOpen] = useState(true);

	const baseUrl = baseURLGlobal;
	const urlParams = new URL(window.location.href);
	const token = urlParams.searchParams.get("token");
	const text = tutorWebConfig.text || {};
	const images = tutorWebConfig.images || {};
	const colors = tutorWebConfig.colors || {};
	const campaignWebStyle = {
		'--tutor-web-page-background': `url("${resolveTutorWebAsset(images.page_background || 'https://cdn-wl-assets.classplus.co/production/379965/2418e3f4-1798-44e9-953a-9301d4684a4d.png')}")`,
		'--tutor-web-warm-text': globalColors.subheading || '#6C2718',
		'--tutor-web-accent-text': globalColors.accent_color || '#E35C22',
		'--tutor-web-highlight': globalColors.accent_color || '#E35C22',
		'--tutor-web-icon-color': globalColors.accent_color || '#E35C22',
		'--tutor-web-rank-badge-border': toRgba(globalColors.heading_color, 0.3) || '#232E4F4D',
		'--tutor-web-card-border': globalColors.accent_color || '#E35C22',
		'--tutor-web-progress-fill': globalColors.accent_color || '#E35C22',
		'--tutor-web-progress-track': colors.progress_track || 'rgba(108, 39, 24, 1)',
		'--tutor-web-task-cta-background': globalColors.accent_color || '#E35C22',
		'--tutor-web-primary-cta-text': globalColors.button_text || 'white',
		'--tutor-web-rank-badge-background': globalColors.page_background || '#FEF2DF',
		'--tutor-web-panel-background': colors.panel_background || '#FBEFDDD6',
		'--tutor-web-card-background': colors.card_background || '#F9E6A8',
		'--tutor-web-completed': globalColors.success_color || '#0D913E',
		'--tutor-web-primary-text': globalColors.heading_color || '#232E4F',
	};

	const coinTasksData = data?.statCardWeb?.filter((item) => !item?.isComplete);
	const bottomCardWebData = data?.bottomCardWeb;
	const campaignOrg = data?.campaignOrg;
	const tutorData = data?.tutorOfTheDayCard;

	const iconAnimationFile = {
		loop: true,
		autoplay: true,
		animationData: iconAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};


	const openFrameFun = (type) => {
		const iframeOrigin = process.env.NODE_ENV === 'development' ? window.location.origin : config.BANNER_URL;
		const urlBase = `${iframeOrigin}/tutor/details/`;
		let url;
		switch (type) {
			case "overview":
				url = `${urlBase}overview?token=${token}`;
				break;
			case "leaderboard":
				url = `${urlBase}leaderboard?token=${token}`;
				break;
			default:
				url = `${urlBase}tasks?token=${token}`;
		}
		setFrameUrl(url);
		setShowTutorFrame(true);
	};

	useEffect(() => {
		var myHeaders = new Headers();
		myHeaders.append('x-access-token', token);
		var requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow',
		};
		fetch(`${baseUrl}/v1/campaign/homeCard`, requestOptions)
			.then((response) => response.json())
			.then((result) => {
				setData(result.data);
			});
	},[]);

	const closedTutorFrameFun = () => {
		setShowTutorFrame(false);
		setFrameUrl("");
	};

	useEffect(() => {
		const handleMessage = (event) => {
			const trustedOrigin = "https://campaigns.classplus.co";
			if (event.origin === trustedOrigin) {
				if (event.data?.type === "superSetOpened") {
					setIsOpen(false);
				} else if (event.data?.type === "modalClosed") {
					setIsOpen(true);
				}
			} else {
				console.warn("Untrusted origin:", event.origin);
			}
		};
		window.addEventListener("message", handleMessage);
		return () => {
			window.removeEventListener("message", handleMessage);
		};
	}, []);

	return (
		<>
			<div className="campaign-web" style={campaignWebStyle}>
				<div className="flex-column-box">
					<div className="campaign-web-left">
						<div className="web-top-header">
							<img className="title"
								 src={resolveTutorWebAsset(images.title_artwork || 'https://cdn-wl-assets.classplus.co/production/379965/4a17619f-0403-49de-aebe-addcbdfe5cf4.png')}
								 alt="title"/>
						</div>
						{/* <div className="campaign-divider"></div> */}

						<div className="campaign-revenue-box">
							<div className="campaign-border"></div>
							<div className="campaign-revenue">
								<h4>{globalText.revenue_label || 'Your Revenue'}</h4>
								<h1>{data?.homeCard?.revenueCard?.total}</h1>
							</div>
							<div className="campaign-rank">
								<RankIcon className="campaign-web-icon campaign-rank-icon"/>
								{data?.homeCard?.rankCard?.title} {text.rank_suffix || 'Rank'}
							</div>
						</div>
						<div className="campaign-progress-bar">
							<ProgressMeter
								width={data?.homeCard?.revenueCard?.progressBar > 100 ? 100 : data?.homeCard?.revenueCard?.progressBar}
								thick={18}
								isQualified={true}
								data={data?.homeMileStone?.revenue}>
							</ProgressMeter>
						</div>
						<div className="progress-completed">
							<h4>{data?.homeCard?.revenueCard?.progressBar >= 100 ? '100' : data?.homeCard?.revenueCard?.progressBar}{text.progress_suffix || '% Completed'}</h4>
							<h4 style={{color: globalColors.subheading || "rgba(108, 39, 24, 1)"}}>{globalText.goal_prefix || 'Goal:'}&nbsp; {data?.homeCard?.revenueCard?.goal}</h4>
						</div>
						
						{/* <div className="campaign-carousel-caption">
							<h4>The 3x Store</h4>
							<p>3x your earnings by our Specialised features & get chance to win amazing gifts.</p>
						</div>
						<div className="sleekCarouselContainer">
							<SleekCarousel bottomCardData={bottomCardWebData} campaignOrg={campaignOrg}/>
						</div> */}
						
					</div>
					<div className="campaign-web-right">
						<div className="campaign-message-box">
							<h3>{text.message_heading || 'Share a gift to your students'}</h3>
							<div className="campaign-message" onClick={() => openFrameFun('overview')}>
								<MessageIcon className="campaign-web-icon campaign-message-icon"/>
								{text.message_cta_label || 'Send a special message to your students'}
								<ArrowRightIcon className="campaign-web-icon campaign-message-arrow"/>
							</div>
						</div>
						{tutorData &&
							<div className="campaign-tutor-web">
								<div className="tutor-column-header">
									<h3>{text.tutor_of_the_day_heading || 'Tutor of the day'}</h3>
									<button onClick={() => openFrameFun('leaderboard')}>{globalText.view_leaderboard_label || 'View Leaderboard'}<ArrowRightIcon className="campaign-web-icon campaign-header-arrow"/></button>
								</div>
								<div className="campaign-tutor">
									<img src={tutorData?.orgLogo} alt="logo" width={56}/>
									<p>{tutorData?.orgName}</p>
								</div>
							</div>
						}
						<div className='campaign-task-container'>
							<div className="task-column-header">
								<h3>{text.task_heading || 'Complete task & win big'}</h3>
								<button onClick={() => openFrameFun('tasks')}>{globalText.view_tasks_label || 'View All Tasks'}<ArrowRightIcon className="campaign-web-icon campaign-header-arrow"/></button>
							</div>
							{coinTasksData?.slice(!tutorData ? 0 : 1, 2)?.map((item, i) => {
								return (
									<div className='campaign-task-column' key={i}>
										<div className='task-card-first-row'>
											<div className='task-card-upper-row'>
												<div className='task-title-wrapper'>
													<div className='task-title'>{item?.task}</div>
													{item?.statType === 3 ? (
														<p className='task-title-small'>{item?.completedText}</p>
													) : (
														<p className='task-title-small'>{item?.total || 0} {item?.completedText}</p>
													)}
												</div>
												<ProgressMeter
													width={item?.percentage}
													isQualified={true}
													data={data?.homeMileStone?.revenue}
												></ProgressMeter>
											</div>
											<div className='task-coin-wrapper'>
												<PointsIcon className="campaign-web-icon campaign-points-icon"/>
												<p className='task-title-small'>{item?.points} {globalText.points_label || 'Points'}</p>
											</div>
											<div className='task-coin-wrapper'>
												<button className='task-card-btn'
														onClick={() => openFrameFun('tasks')}>{item?.button?.text}
												</button>
											</div>
										</div>
										<span className='task-divider-line'></span>
										<div className='task-card-second-row'>
											{item?.taskInfo}
										</div>
									</div>
								)
							})}
						</div>
					</div>
				</div>
			</div>
			{showTutorFrame &&
				<div className={`${'campaignPopUp campaignPopUpFrame show'}`} style={{'--campaign-popup-header-background': globalColors.popup_header_background || 'rgba(95, 34, 24, 1)'}}>
					<div className="campaignPopUpContent">
						{isOpen && <div className="campaignPopUpHeader">
							<h4>{text.frame_header_title || 'Independence Day Sale 2026'}</h4>
							<button onClick={closedTutorFrameFun}><img
								src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/modal-close-icon.png"
								width={24} alt="icon"/></button>
						</div>}
						<div className="campaignPopUpBody">
							<iframe
								className="campaign-tutor-frame"
								ref={iframeRef}
								src={frameUrl}
								allow="fullscreen; autoplay"
								sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
							></iframe>

						</div>
					</div>
					{/*<div className="campaign-close-overlay" onClick={closedTutorFrameFun}></div>*/}
				</div>
			}
		</>
	);
};

export default withRouter(Campaign);
